export default {
    'master-key-numbers': require( './master/key-numbers.js' ),
    'master-two-columns': require( './master/two-columns.js' ),
    'master-media-gallery': require( './master/media-gallery.js' ),
    'details-hirondelle': require( './details-hirondelle.js' ),
    'map': require( './map/map' ),
    'census-container': require( './census/census' ),
    'census-fast-container': require( './census-fast/census-fast' ),
}
